import { useShoppingCartStore } from "@multicines/stores";
import { getShoppingCartTotalByVendor } from "@multicines/utils";
import React, { useMemo } from "react";

import { getSelectedVendor } from "./ButtonTotal.helpers";
import Styles from "./ButtonTotal.styles";
import { ButtonTotalProps as Props } from "./ButtonTotal.types";
import useI18n from "hooks/useI18n";
import useUtils from "hooks/useUtils";
import { useStoresStore } from "stores/stores/stores.store";

const ButtonTotal: React.FC<Props> = props => {
  const { onClick, title, className, vendor, isLoading, disabled } = props;
  const { fromCheckout } = props;
  const shoppingCart = useShoppingCartStore(store => store.shoppingCart);
  const t = useI18n();
  const { formatByCurrency } = useUtils();
  const selectedStore = useStoresStore(store => store.selectedStore);

  const [ticketStore, snackStore] = selectedStore ?? [];
  const { vendor: snackVendor } = snackStore ?? {};
  const { id: selectedSnackVendorId } = snackVendor ?? {};
  const { vendor: ticketVendor } = ticketStore ?? {};
  const { id: selectedTicketVendorId } = ticketVendor ?? {};

  const totals = useMemo(() => {
    const selectedVendor = getSelectedVendor(
      vendor,
      selectedTicketVendorId,
      selectedSnackVendorId
    );
    return getShoppingCartTotalByVendor(shoppingCart, selectedVendor);
  }, [selectedSnackVendorId, selectedTicketVendorId, shoppingCart, vendor]);
  const loadingStyle = isLoading ? "ButtonTotal__loading" : [];

  return (
    <Styles
      className={`ButtonTotal ${className} ${loadingStyle}`}
      onClick={onClick}
      disabled={disabled}
    >
      <div className="ButtonTotal__wrapper">
        <p className="ButtonTotal__text">{title ?? t.common.continue}</p>
        <p className="ButtonTotal__text">
          {fromCheckout ?? formatByCurrency(totals?.total)}
        </p>
      </div>
    </Styles>
  );
};

export default ButtonTotal;
